import {
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineOppositeContent,
} from '@mui/lab';
import { Grid, Avatar, Button, Typography, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { FaDotCircle } from 'react-icons/fa';
import { HiOutlineBriefcase } from 'react-icons/hi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getJobByJobCode } from 'wisestep-api';
import {
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  WsIconText,
  WsColors,
  formatDayToTime,
  WsChip,
  WsChipSize,
  WsChipVariants,
} from 'wisestep-base';

import { getUserAnalyticsUrl } from '../../../../../../../features/candidates/utils/CandidateHelper';
import { openUrlInNewTab } from '../../../../../../../utils/openUrlInNewTab';
import { SubmissionType } from '../../../../../../conversationWidget/types/SubmissionTypes';
import { StyledChip } from '../../../../childComponets/jobCard/JobCard';
import {
  action,
  ActivityLogItemProps,
  iconBg,
  separatorIcons,
  viewButton,
} from '../../utils/helper';

export const StyledGrid = styled(Grid)({
  border: '1px solid #EAEAF1',
  borderRadius: '6px',
  fontSize: '8px',
  width: '400px',
  background: '#F6F6F9',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  color: '#484D6D',
  marginLeft: '4px',
});

const ActivityLogItem = ({
  index,
  activity,
  isLast = false,
  onclick,
  openPreview,
  logId,
  auditId,
  rowId,
  selectedButtonId,
  onClickView,
}: ActivityLogItemProps) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const url = window.location.href;
  const actionType = activity.activityType ?? '';
  const isCommunication =
    actionType === 'SMS' || actionType === 'EMAIL' || actionType === 'Communication';
  const isSubmission = actionType === 'SUBMISSION_CREATED' || actionType === 'SUBMISSION_ACTION';
  const displayPreview =
    (isCommunication ||
      actionType === 'INTERACTION' ||
      actionType === 'SUBMISSION_CREATED' ||
      actionType === 'SUBMISSION_UPDATED' ||
      actionType === 'SUBMISSION_ACTION' ||
      actionType === 'PIPELINE') &&
    url.includes('activity-logs');

  const displayProfileUpdatePreview =
    actionType === 'CANDIDATE_UPDATED' || actionType === 'UPDATE_SUBMISSION';

  const navigateToPath = (path: string) => {
    navigate(
      `/candidate-layout/${path}?id=${params.get('id')}&array=${params.get('array')}&jobId=${
        activity?.jobId
      }`
    );
  };

  const openChangeDialog = () => {
    openPreview && openPreview(!(selectedButtonId === rowId[index].id));
    logId && logId(auditId ?? '');
    onClickView(rowId[index].id);
  };

  const onActivityClick = () => {
    if (actionType === 'SMS' || actionType === 'EMAIL' || actionType === 'Communication') {
      onclick && onclick(activity);
    } else if (actionType === 'INTERACTION') {
      navigateToPath('mappings');
    } else if (
      actionType === 'SUBMISSION_CREATED' ||
      actionType === 'SUBMISSION_UPDATED' ||
      actionType === 'PIPELINE' ||
      actionType === 'SUBMISSION_ACTION'
    ) {
      navigateToPath('submissions');
    }
  };
  const onRecruiterNameClick = async () => {
    const url = await getUserAnalyticsUrl(activity?.recruiterId ?? '');
    openUrlInNewTab(url);
  };
  const onJobNameClick = async () => {
    const jobResponse = await getJobByJobCode(activity?.jobCode ?? '');
    openUrlInNewTab(`/jobs-crm/${jobResponse.data.id}/false/0/pipeline/`);
  };
  const allContactActions =
    activity.contactActionsObjs?.flatMap((contactObj) => [
      ...(contactObj.actions || []),
      ...(contactObj.result?.result || []),
    ]) || [];

  const maskEmail = (email: string) => {
    const [name, domain] = email.split('@');
    if (!domain) return email;
    return name.slice(0, 2) + '***@' + domain;
  };

  const maskPhoneNumber = (number: string) => {
    if (!number || number.length < 4) return number; // Return as is if invalid
    return '*'.repeat(number.length - 4) + number.slice(-4);
  };
  return (
    <TimelineItem>
      <TimelineOppositeContent color="text.secondary" alignContent={'center'}>
        {`${formatDayToTime(activity.createdOn)}`}
      </TimelineOppositeContent>
      <TimelineSeparator>
        {index === 0 && <FaDotCircle color={WsColors.GreyBlack} />}
        <TimelineConnector sx={{ height: 20 }} />
        <Avatar sx={{ bgcolor: iconBg[actionType] }}>{separatorIcons[actionType]}</Avatar>
        <TimelineConnector sx={{ height: 40 }} />
        {isLast && <FaDotCircle color={WsColors.GreyBlack} />}
      </TimelineSeparator>
      <TimelineContent alignContent="center">
        <Grid display="flex" justifyContent="space-between" ml={1}>
          <Grid item>
            <Grid container gap={0.5} rowSpacing={1}>
              <Grid item display="flex" gap={0.5} direction="row">
                <WsTypography
                  color={WsTypoColors.PRIMARY}
                  variant={WsTypoVariants.BODY1}
                  bold
                  onClick={onRecruiterNameClick}
                  cursor="pointer"
                >
                  {activity.recruiterName ?? activity.recruiterId}
                </WsTypography>
                {isSubmission && activity?.submissionType && (
                  <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1}>
                    {activity.submissionType === SubmissionType.EXTERNAL
                      ? 'has externally'
                      : 'has internally'}
                  </WsTypography>
                )}
                <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1}>
                  {action[actionType]}
                </WsTypography>
                {/* <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1} bold>
                  {candidateViewData?.name}
                </WsTypography> */}
                {isCommunication && (
                  <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1}>
                    to
                  </WsTypography>
                )}
                {activity.jobTitle && !isSubmission && !displayProfileUpdatePreview && (
                  <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1} bold>
                    {`to ${activity.jobTitle} (${activity.jobCode})`}
                  </WsTypography>
                )}
                {isSubmission && activity?.submissionType && (
                  <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1} bold>
                    {`to ${
                      activity.submissionType === SubmissionType.EXTERNAL
                        ? `${activity?.jobTitle} (${activity?.jobCode})`
                        : activity?.assignToUserName ?? activity?.assignTo
                    }`}
                  </WsTypography>
                )}
                {isCommunication && (
                  <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1}>
                    {`at ${
                      activity.toEmail
                        ? maskEmail(activity.toEmail)
                        : maskPhoneNumber(activity.toNumber ?? '')
                    }`}
                  </WsTypography>
                )}
              </Grid>
              {(activity.status ||
                activity.applicationStage ||
                activity.applicationState ||
                activity?.emailStatus ||
                activity.contactActionsObjs) && (
                <Grid container item columnSpacing={1} rowSpacing={1} ml={1}>
                  {activity.status && (
                    <StyledChip
                      label={activity.status}
                      textColor={WsColors.White}
                      bgColor={WsColors.BackGroundGreen}
                      mt={1}
                    />
                  )}
                  {activity?.emailStatus && (
                    <StyledChip
                      label={activity.emailStatus}
                      textColor={WsColors.White}
                      bgColor={WsColors.BackGroundGreen}
                      mt={1}
                    />
                  )}
                  {activity.applicationStage && (
                    <WsChip
                      value={activity.applicationStage}
                      size={WsChipSize.MEDIUM}
                      variant={WsChipVariants.STAGE}
                      borderColor={WsColors.TheBlues400}
                    />
                  )}
                  {activity.applicationState && (
                    <WsChip
                      value={activity.applicationState}
                      size={WsChipSize.MEDIUM}
                      variant={WsChipVariants.STATUS}
                      borderColor={WsColors.YellowBorder}
                    />
                  )}

                  {allContactActions?.length > 0 &&
                    allContactActions.map((contactAction, index) => (
                      <StyledChip
                        key={index}
                        label={contactAction}
                        textColor={WsColors.White}
                        bgColor={WsColors.BackGroundGreen}
                        mt={1}
                      />
                    ))}
                  {activity.contactActionsObjs?.length > 0 &&
                    activity.contactActionsObjs?.[0].notes && (
                      <Grid container direction="column" spacing={1} mt={0.5}>
                        <Grid item fontWeight={6}>
                          <WsTypography bold={true}>
                            Notes Added by {`${activity.recruiterName ?? ''}`}
                          </WsTypography>
                        </Grid>
                        <StyledGrid p={1}>
                          <Typography>{activity.contactActionsObjs?.[0]?.notes}</Typography>
                        </StyledGrid>
                      </Grid>
                    )}
                  {!isEmpty(activity?.notes) && (
                    <Grid container direction="column" spacing={1} mt={0.5}>
                      <Grid item fontWeight={6}>
                        <WsTypography bold={true}>Latest Notes</WsTypography>
                      </Grid>
                      <StyledGrid p={1}>
                        <WsTypography color={WsTypoColors.GREYTEXT2}>
                          {activity?.notes}
                        </WsTypography>
                      </StyledGrid>
                    </Grid>
                  )}
                </Grid>
              )}
              {activity.jobTitle && (
                <Grid container item ml={1.5}>
                  <WsIconText
                    icon={<HiOutlineBriefcase fontSize={20} />}
                    text={`${activity.jobTitle} (${activity.jobCode})`}
                    textSize={WsTypoVariants.BODY1}
                    textColor={WsTypoColors.TERTIARY900}
                    popOverText="Job title"
                    textCursor="pointer"
                    onClick={onJobNameClick}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          {displayPreview && (
            <Grid item>
              <Button
                variant="outlined"
                onClick={onActivityClick}
                sx={{
                  whiteSpace: 'nowrap',
                }}
              >{`View ${viewButton[actionType]}`}</Button>
            </Grid>
          )}
          {displayProfileUpdatePreview && (
            <Grid item>
              <Button
                key={index}
                variant={`${
                  selectedButtonId && selectedButtonId != '' && selectedButtonId === rowId[index].id
                    ? 'contained'
                    : 'outlined'
                }`}
                onClick={openChangeDialog}
                sx={{
                  whiteSpace: 'nowrap',
                }}
              >{`${
                selectedButtonId === rowId[index].id ? 'Hide Changes' : 'View Changes'
              }`}</Button>
            </Grid>
          )}
        </Grid>
      </TimelineContent>
    </TimelineItem>
  );
};
export default ActivityLogItem;
